import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=0a22f4a4"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a22f4a4')) {
      api.createRecord('0a22f4a4', component.options)
    } else {
      api.reload('0a22f4a4', component.options)
    }
    module.hot.accept("./brand.vue?vue&type=template&id=0a22f4a4", function () {
      api.rerender('0a22f4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/sector/brand.vue"
export default component.exports